const KycStepEnum = {
  PRE_JUMIO: "before",
  LOADING: "loading",
  RESULT: "result",
  REVIEW_NAME_NRIC: "reviewNameNric",
};

export default KycStepEnum;
